import { render, staticRenderFns } from "./OnboardingDashboardName.vue?vue&type=template&id=0154ee37&scoped=true&"
import script from "./OnboardingDashboardName.vue?vue&type=script&lang=js&"
export * from "./OnboardingDashboardName.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDashboardName.vue?vue&type=style&index=0&id=0154ee37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154ee37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
